export const SlotStatusList = [
  { value: "new", label: "New" },
  { value: "onHold", label: "On Hold" },
  { value: "limitedQuantity", label: "Limited Quantity" },
  { value: "fullyBooked", label: "Fully Booked" },
  { value: "notAvailable", label: "Not Available" },
];
